import React from 'react';
import './PageTemplate.css';

interface PageTemplateProps {
  title: string;
  description: string;
  children: React.ReactNode;
  headerExtra?: React.ReactNode;
}

const PageTemplate: React.FC<PageTemplateProps> = ({ title, description, children, headerExtra }) => {
  return (
    <div className="page-template-container">
      <div className="page-header">
        <h1>{title}</h1>
        <p>{description}</p>
        {headerExtra && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
            {headerExtra}
          </div>
        )}
      </div>
      
      <div className="page-content">
        {children}
      </div>
    </div>
  );
};

export default PageTemplate; 